import Promise from 'bluebird';

export function pluralize(singular, count = 0, plural) {
  if (!singular) return '';
  if (!plural) plural = singular + 's';
  return count === 1 ? singular : plural;
}

export function capitalize(phrase = '') {
  return phrase
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function withConjunction(list = []) {
  if (list.length === 0) return '';
  if (list.length === 1) return `${list[0]}`;
  if (list.length === 2) return `${list[0]} and ${list[1]}`;
  return `${list.slice(0, list.length - 1).join(', ')}, and ${list[
    list.length - 1
  ]}`;
}

// https://stackoverflow.com/questions/35228052/debounce-function-implemented-with-promises
export function debounce(inner, ms = 0) {
  let timer = null;
  let resolves = [];

  return function(...args) {
    // Run the function after a certain amount of time
    clearTimeout(timer);
    timer = setTimeout(() => {
      // Get the result of the inner function, then apply it to the resolve function of
      // each promise that has been created since the last time the inner function was run
      let result = inner(...args);
      resolves.forEach(r => r(result));
      resolves = [];
    }, ms);

    return new Promise(r => resolves.push(r));
  };
}

export function isMobileDevice() {
  if (typeof window === 'undefined') return;
  return /iPhone|iPod|iPad|Android/i.test(window.navigator.userAgent);
}

export function scrollToTop() {
  if (typeof window === 'undefined') return;
  window.scrollTo(0, 0);
  setTimeout(
    () => document.documentElement.setAttribute('data-scrolldir', 'up'),
    0
  );
}



// WEBPACK FOOTER //
// ./shared/utils/index.js